import { render, staticRenderFns } from "./fullScreenGalleryCard.vue?vue&type=template&id=143debd1&"
import script from "./fullScreenGalleryCard.vue?vue&type=script&lang=js&"
export * from "./fullScreenGalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./fullScreenGalleryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports